import React from 'react';
import { Skeleton } from '../../../ui/Skeleton';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { NavMenu } from './NavMenu';

export const WorkspaceSelectorSkeleton = React.memo(() =>
    <Flexer flex="row" gap=".5">
        <Flexer grow>
            <Skeleton width="100%" height="2.75" rounding=".25" />
        </Flexer>
        <Flexer flex="row" center>
            <NavMenu.Item>
                <NavMenu.ItemIcon>
                    <Skeleton width="2" height="2" />
                </NavMenu.ItemIcon>
            </NavMenu.Item>
        </Flexer>
    </Flexer>
);

